import {Component, OnDestroy, OnInit} from '@angular/core';
import {NetworkService} from "../../services/network.service";
import {Router} from "@angular/router";
import {
    getUrlImplante,
    qtdLinhas,
} from "../../controller/staticValues";
import {MessageService} from "primeng/api";
import {Subscription} from "rxjs";
import {DadosDefaultService} from "../../services/dados-default.service";

@Component({
    selector: 'app-holding',
    templateUrl: './holding.component.html',
    styleUrls: ['./holding.component.css'],
    standalone: false
})
export class HoldingComponent implements OnInit{

    public first: number = 0
    public top: number = qtdLinhas()
    qtdLinhas = qtdLinhas();
    public totalItens: number = 0
    public lista: any[] = []
    public dadosFixos: any[] = []


    opcoesTable = [
        {label: 'Editar', icon: 'fa fa-plus', command: (e: any) => {
            this.router.navigate([`editar-holding/${e.ID}`])
        }},
        {label: 'Incluir', icon: 'fa fa-plus', command: (e: any) => {
            this.router.navigate(['incluir-holding'])
        }},
    ]

    constructor(private networkService: NetworkService, private router: Router, private messageService: MessageService, private dadosDefaultService: DadosDefaultService) {

    }

    ngOnInit() {
        this.networkService.getSimples(getUrlImplante(), 'HOLDING').subscribe((v: any) => {
            this.lista = v.value
            this.dadosFixos = v.value
            this.totalItens = v.length
        })
    }

    incluir(){
        this.router.navigate(['incluir-holding'])
    }
}
